// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__7jPap","overlay":"Hero_overlay__Uxk+S","heroContent":"Hero_heroContent__YokLE","btn":"Hero_btn__adf-v"};